import React from 'react';

import styles from './styles.module.scss';

const Loader: React.FC = () => {
  return (
    <div className={styles.loading}>
      <span className={styles.loading_dot}></span>
      <span className={styles.loading_dot}></span>
      <span className={styles.loading_dot}></span>
    </div>
  );
};

export default Loader;
